"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _appButton = _interopRequireDefault(require("../app-button/app-button"));

const PrimaryButton = props => {
  const {
    className
  } = props,
        otherProps = (0, _objectWithoutProperties2.default)(props, ["className"]);
  return /*#__PURE__*/_react.default.createElement(_appButton.default, (0, _extends2.default)({}, otherProps, {
    className: (0, _classnames.default)('primary-button', className)
  }));
};

PrimaryButton.propTypes = {
  className: _propTypes.default.string
};
PrimaryButton.defaultProps = {
  className: ''
};
var _default = PrimaryButton;
exports.default = _default;